var SOUND_EMPTY = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq',
    SOUND_RING = OK.cnst.staticUrl + 'res/default/sound/videochat/ring.mp3',
    SOUND_OLGA = OK.cnst.staticUrl + 'res/default/sound/videochat/olga.mp3',
    SOUND_BUSY = OK.cnst.staticUrl + 'res/default/sound/videochat/busy.mp3',
    SOUND_CONNECTING = OK.cnst.staticUrl + 'res/default/sound/videochat/connecting.mp3',
    SOUND_BEEP = OK.cnst.staticUrl + 'res/default/sound/videochat/beep.mp3',
    SOUND_DROP = OK.cnst.staticUrl + 'res/default/sound/videochat/drop.mp3';

var _audio = null,
    _canPlay = true,
    _delayTimeout = null;

// Прогреваем аудио элемент
_initAudioElement();

function _initAudioElement() {
    try {
        _audio = new Audio();
        _audio.preload = 'auto';
        _audio.autoplay = false;
        _audio.loop = false;
        _audio.src = SOUND_EMPTY;

        var _playPromise = _audio.play();
        if (!_playPromise) {
            // Какой-то старый браузер
            _canPlay = false;
            return;
        }

        _playPromise['catch'](function(e) {
            if (e.name === 'NotAllowedError') {
                // Автоплей заблокирован
                window.addEventListener('click', function _waitUnblockAutoplay() {
                    _canPlay = true;
                    window.removeEventListener('click', _waitUnblockAutoplay);
                });
                _canPlay = false;
            }
        });
    } catch (e) {
        // Не умеем аудио вообще
        _canPlay = false;
    }
}

function _play(sounds, loop, delay) {
    stop();

    if (!_canPlay) {
        return;
    }

    if (!Array.isArray(sounds)) {
        sounds = [sounds];
    }
    delay = delay || 0;

    var index = 0,
        length = sounds.length;

    function _playNow() {
        _audio.onended = function() {
            index = (index + 1) % length;

            if (!loop && !index) {
                stop();
            } else {
                _delayTimeout = setTimeout(function() {
                    _delayTimeout = null;
                    _audio.src = sounds[index];
                    _audio.play();
                }, delay);
            }
        };

        _audio.oncanplay = null;
        _audio.src = sounds[index];
        _audio.play();
    }

    if (!_audio.src || _audio.readyState > _audio.HAVE_FUTURE_DATA) {
        _playNow();
    } else {
        _audio.oncanplay = _playNow;
    }
}

function incoming(sound) {
    _play(sound || [SOUND_RING, SOUND_OLGA], true);
}

function busy() {
    _play(SOUND_BUSY);
}

function connecting() {
    _play(SOUND_CONNECTING, true, 2000);
}

function calling(sound) {
    _play(sound || SOUND_BEEP, true);
}

function drop() {
    _play(SOUND_DROP);
}

function stop() {
    if (_audio && _audio.src) {
        _audio.onended = null;
        _audio.oncanplay = null;
        _audio.pause();
        _audio.removeAttribute('src');
    }
    if (_delayTimeout) {
        clearTimeout(_delayTimeout);
        _delayTimeout = null;
    }
}

export default { incoming, busy, connecting, calling, drop, stop };

export { incoming, busy, connecting, calling, drop, stop };
